<template>
  <section slot="pdf-content" ref="html2pdf">
    <div
      class="gala__resume py-10 lg:px-12"
      id="lightcharactercard"
      ref="lightcharactercardDocument"
    >
      <div class="character">
        <div>
          <img
            class="character__display-pic"
            :style="{ borderColor: colorObj }"
            v-if="userData.profilePictureUrl"
            :src="
              userProfilePicture
                ? userProfilePicture
                : constants.s3Bucket +
                  '/editor/profile-pictures/' +
                  userData.profilePictureUrl
            "
          />
          <img
            class="character__display-pic"
            :style="{ borderColor: colorObj }"
            v-else
            :src="defaultAvatar"
          />
        </div>
        <div class="character__name__address md:block lg:hidden">
          <h2
            class="text-lg font-semibold name__address__username"
            :style="{ color: colorObj }"
          >
            {{ userData.firstName }} {{ userData.lastName }}
          </h2>
          <h3 v-if="userData.profession" class="mb-2 md:font-normal text-base">
            {{ userData.profession }}
          </h3>
          <div v-if="userData.address" class="my-4 font-medium">
            <h4 class="text-sm"><b>Location:</b> {{ userData.address }}</h4>
            <h4 v-if="userData.contactNumber" class="text-sm">
              <b>Contact No. : </b>{{ userData.contactNumber }}
            </h4>
            <h4 v-if="userData.email" class="text-sm">
              <b>Email : </b>{{ userData.email }}
            </h4>
          </div>
        </div>
        <div class="w-full md:block lg:hidden">
          <hr />
        </div>
        <div
          v-if="
            userData.twitterProfile ||
            userData.facebookProfile ||
            userData.linkedinProfile ||
            userData.website
          "
          class="my-3 md:block lg:hidden"
        >
          <div class="social flex">
            <a
              target="blank"
              :href="userData.twitterProfile"
              v-if="userData.twitterProfile"
              class="mx-2 flex items-center"
            >
              <img class="w-5 h-5 lg:w-8 lg:h-8" :src="twitter" alt="" />
            </a>
            <a
              :href="userData.facebookProfile"
              target="blank"
              v-if="userData.facebookProfile"
              class="mx-2 flex items-center"
            >
              <img class="w-5 h-5 lg:w-8 lg:h-8" :src="facebook" alt="" />
            </a>
            <a
              :href="userData.linkedinProfile"
              target="blank"
              v-if="userData.linkedinProfile"
              class="mx-2 flex items-center"
            >
              <img class="w-5 h-5 lg:w-8 lg:h-8" :src="linkedin" alt="" />
            </a>
            <a
              :href="userData.personalWebsite"
              target="blank"
              v-if="userData.personalWebsite"
              class="mx-2 flex items-center"
            >
              <img class="w-5 h-5 lg:w-8 lg:h-8" :src="website" alt="" />
            </a>
          </div>
        </div>
        <div class="w-full mb-3 md:block lg:hidden">
          <hr />
        </div>
        <div>
          <vs-tooltip :color="colorObj" :text="selectedGalaAvatar">
            <img
              v-if="selectedGalaAvatar && selectedGalaAvatarGender"
              class="char-img md:block lg:hidden"
              :src="
                selectedGalaAvatar
                  ? require(`@/assets/images/gala-images/Avatar/img/${selectedGalaAvatarGender}/${selectedGalaAvatar}.png`)
                  : ''
              "
              :alt="selectedGalaAvatar ? selectedGalaAvatar : ''"
            />
          </vs-tooltip>
        </div>
        <div class="d-character-types character__values">
          <div class="vx-row">
            <div
              v-for="(ccg, index) in characterCardsGala"
              :key="index"
              class="vx-col w-1/3 lg:w-1/6 items-center"
            >
              <div v-if="ccg" class="cursor-pointer">
                <div
                  class="character__values__value__name"
                  :style="{
                    border: ccg.border,
                    color: ccg.color,
                  }"
                  style="border-radius: 6px 6px 0px 0px"
                >
                  {{ ccg.title }}
                </div>
                <div
                  class="character__values__value__img"
                  :style="{ borderLeft: ccg.border, borderRight: ccg.border }"
                >
                  <img :src="ccg.image" :alt="ccg.title" />
                </div>
                <div
                  class="character__values__value__type-count"
                  :style="{ border: ccg.border, color: ccg.color }"
                  style="border-radius: 0px 0px 6px 6px"
                >
                  {{ getCharacterTypeCount(ccg) }}                
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="user__details--1 my-12">
        <div
          class="user__details--1__name__languages pr-0 lg:pr-5 relative z-10"
        >
          <div class="flex">
            <div class="name__social md:hidden lg:block">
              <div class="name__address">
                <h2
                  class="text-5xl font-bold name__address__username"
                  :style="{ color: colorObj }"
                >
                  {{ userData.firstName }} {{ userData.lastName }}
                </h2>
                <h3 v-if="userData.profession" class="my-4 font-semibold">
                  {{ userData.profession }}
                </h3>
                <h4 v-if="userData.email" class="my-2 break-words">
                  <b>Email : </b>{{ userData.email }}
                </h4>
                <h4 v-if="userData.contactNumber">
                  <b>Contact No. : </b>{{ userData.contactNumber }}
                </h4>
                <div v-if="userData.address" class="my-4">
                  <h4>
                    <b>Address:</b> <br />
                    <div class="address">
                      {{ userData.address }}
                    </div>
                  </h4>
                </div>
              </div>
              <div
                v-if="
                  userData.twitterProfile ||
                  userData.facebookProfile ||
                  userData.linkedinProfile ||
                  userData.website
                "
                class="social"
                :style="{ borderColor: colorObj }"
              >
                <h2
                  :style="{ color: colorObj }"
                  class="font-bold text-center mb-2"
                >
                  Social
                </h2>
                <a
                  target="blank"
                  :href="userData.twitterProfile"
                  v-if="userData.twitterProfile"
                  class="my-2 flex items-center"
                >
                  <img class="w-8 h-8" :src="twitter" alt="" />
                  <p class="ml-2 text-xl font-bold text-black">
                    @{{ getTwitterUsername(userData.twitterProfile) }}
                  </p>
                </a>
                <a
                  :href="userData.facebookProfile"
                  target="blank"
                  v-if="userData.facebookProfile"
                  class="my-2 flex items-center"
                >
                  <img class="w-8 h-8" :src="facebook" alt="" />
                  <p class="ml-2 text-xl font-bold text-black">
                    @{{ getFacebookUsername(userData.facebookProfile) }}
                  </p>
                </a>
                <a
                  :href="userData.linkedinProfile"
                  target="blank"
                  v-if="userData.linkedinProfile"
                  class="my-2 flex items-center"
                >
                  <img class="w-8 h-8" :src="linkedin" alt="" />
                  <p class="ml-2 text-xl font-bold text-black">
                    @{{ getLinkedinUsername(userData.linkedinProfile) }}
                  </p>
                </a>
                <a
                  :href="userData.personalWebsite"
                  target="blank"
                  v-if="userData.personalWebsite"
                  class="my-2 flex"
                >
                  <img class="w-8 h-8" :src="website" alt="" />
                  <p class="ml-2 text-xl break-all font-bold text-black">
                    {{ removeHttp(userData.personalWebsite) }}
                  </p>
                </a>
              </div>
            </div>
            <div class="char absolute opacity-50">
              <vs-tooltip :color="colorObj" :text="selectedGalaAvatar">
                <img
                  v-if="selectedGalaAvatar && selectedGalaAvatarGender"
                  class="char-img md:hidden lg:block"
                  :src="
                    selectedGalaAvatar
                      ? require(`@/assets/images/gala-images/Avatar/img/${selectedGalaAvatarGender}/${selectedGalaAvatar}.png`)
                      : ''
                  "
                  :alt="selectedGalaAvatar ? selectedGalaAvatar : ''"
                />
              </vs-tooltip>
            </div>
          </div>
          <div
            v-if="
              userData.extraCurricular[0].languages &&
              userData.extraCurricular[0].languages.length > 0
            "
            class="languages md:hidden lg:block"
          >
            <h2
              class="languages__heading font-bold text-center mb-2"
              :style="{ color: colorObj }"
            >
              Languages
            </h2>
            <h4
              :style="{ backgroundColor: colorObj + '99' }"
              v-for="(language, index) in userData.extraCurricular[0].languages"
              :key="index"
              class="my-4"
            >
              <span v-if="language && language.title && language.title.label">{{
                language.title.label
              }}</span>
            </h4>
          </div>
        </div>
        <div class="user__details--1__aboutme-edu md:block lg:hidden">
          <div
            v-if="userData.about"
            :style="{ borderColor: colorObj }"
            class="about-me"
          >
            <h2
              class="about-me__title font-bold mb-2 relative z-10"
              :style="{ color: colorObj }"
            >
              About Me
            </h2>
            <p
              class="about-me__details text-justify lg:text-xl lg:font-bold text-black relative z-10"
            >
              {{ userData.about }}
            </p>
          </div>
          <div
            v-if="
              userData.educationalQualifications &&
              userData.educationalQualifications.length > 0
            "
            class="edu mt-6 grid grid-rows-2 grid-cols-2 col-start-1 col-end-1 gap-y-4 gap-x-8 md:gap-x-16 lg:gap-x-64 relative"
            :style="{ borderColor: colorObj }"
          >
            <div
              v-for="(
                eduQualitification, index
              ) in userData.educationalQualifications"
              :key="index"
            >
              <h2
                class="edu__title font-bold mb-2"
                :style="{ color: colorObj }"
              >
                {{ eduQualitification.degreeCertification }}
              </h2>
              <h3 class="edu__details md:font-normal">
                {{ eduQualitification.organization }} |
                <span> {{ formatDate(eduQualitification.startDate) }}</span>
                - {{ formatDate(eduQualitification.endDate) }} (Year) |<span
                  v-if="eduQualitification.grade"
                >
                  {{ eduQualitification.grade }}% |
                </span>
                <span v-if="eduQualitification.city"
                  >{{ eduQualitification.city }} |
                </span>

                <span v-if="eduQualitification.country">{{
                  eduQualitification.country.label
                }}</span>
              </h3>
            </div>
            <div
              :style="{ borderColor: colorObj }"
              class="vertical-bar vertical-bar--edu"
            />
          </div>
        </div>
        <div class="user__details--1__skills__abilities">
          <div class="md:flex flex-col w-full">
            <div
              v-if="
                userData.extraCurricular[0].skills &&
                userData.extraCurricular[0].skills.length > 0
              "
              class="skills"
              :style="{ borderColor: colorObj }"
            >
              <h2
                class="skills__heading font-bold text-center mb-2"
                :style="{ color: colorObj }"
              >
                Skills
              </h2>
              <div class="skills__list overflow-auto">
                <div
                  class="flex my:1.5 lg:my-2"
                  v-for="(skill, index) in userData.extraCurricular[0].skills"
                  :key="index"
                >
                  <!-- <span class="oval__bullets" />  -->
                  <img
                    class="skills__h-fit"
                    :src="bulletsImg[userData.templateColorCode]"
                  />
                  <p
                    v-if="skill && skill.title"
                    class="skills__title ml-2 lg:text-xl font-bold text-black capitalize"
                  >
                    {{ skill.title }}
                  </p>
                </div>
              </div>
            </div>
            <div
              v-if="
                userData.extraCurricular[0].languages &&
                userData.extraCurricular[0].languages.length > 0
              "
              class="languages md:block lg:hidden"
            >
              <h2
                class="languages__title font-bold text-center mb-2"
                :style="{ color: colorObj }"
              >
                Languages
              </h2>
              <h4
                :style="{ backgroundColor: colorObj + '99' }"
                v-for="(language, index) in userData.extraCurricular[0]
                  .languages"
                :key="index"
                class="languages__list my-4"
              >
                <span
                  v-if="language && language.title && language.title.label"
                  >{{ language.title.label }}</span
                >
              </h4>
            </div>
          </div>
          <div class="md:flex flex-col w-full">
            <div
              v-if="
                userData.personality[0].personalityTraitsGala &&
                userData.personality[0].personalityTraitsGala.length > 0
              "
              class="abilities lg:mt-6"
              :style="{ borderColor: colorObj }"
            >
              <h2
                class="abilities__heading font-bold text-center mb-2"
                :style="{ color: colorObj }"
              >
                Abilities
              </h2>
              <div class="abilities__list overflow-auto">
                <div
                  class="flex my:1.5 lg:my-2"
                  v-for="(
                    personalityTraits, index
                  ) in userData.personality[0].personalityTraitsGala.slice(
                    0,
                    6
                  )"
                  :key="index"
                >
                  <!-- <span class="oval__bullets" />  -->
                  <img
                    class="abilities__h-fit"
                    :src="bulletsImg[userData.templateColorCode]"
                  />
                  <p
                    v-if="getPersonalityTraitById(personalityTraits.id)"
                    class="abilities__title ml-2 lg:text-xl font-bold text-black capitalize"
                  >
                    {{
                      $t(getPersonalityTraitById(personalityTraits.id).title)
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div
              v-if="
                userData.extraCurricular[0].hobbies &&
                userData.extraCurricular[0].hobbies.length > 0
              "
              class="hobbies md:block lg:hidden"
              :style="{ borderColor: colorObj }"
            >
              <h2
                class="hobbies__heading font-bold text-center mb-2 relative z-10"
                :style="{ color: colorObj }"
              >
                Hobbies
              </h2>
              <div class="hobbies__list overflow-auto">
                <div
                  class="flex my:1.5"
                  v-for="(hobby, index) in userData.extraCurricular[0].hobbies"
                  :key="index"
                >
                  <!-- <span class="oval__bullets" /> -->
                  <img
                    class="hobbies__h-fit"
                    :src="bulletsImg[userData.templateColorCode]"
                  />
                  <p
                    class="hobbies__title ml-2 font-bold text-black capitalize"
                  >
                    {{ hobby.metaData.label }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="user__details--2 md:hidden lg:flex">
        <div class="aboutme-edu">
          <div
            v-if="userData.about"
            :style="{ borderColor: colorObj }"
            class="about-me"
          >
            <h2
              class="font-bold mb-2 relative z-10"
              :style="{ color: colorObj }"
            >
              About Me
            </h2>
            <p class="text-xl font-bold text-black relative z-10">
              {{ userData.about }}
            </p>
          </div>
          <div
            v-if="
              userData.educationalQualifications &&
              userData.educationalQualifications.length > 0
            "
            class="edu mt-6 grid grid-rows-2 grid-cols-2 col-start-1 col-end-1 gap-x-64 gap-y-4 md:gap-x-16 relative"
            :style="{ borderColor: colorObj }"
          >
            <div
              v-for="(
                eduQualitification, index
              ) in userData.educationalQualifications"
              :key="index"
            >
              <h2 class="font-bold mb-2" :style="{ color: colorObj }">
                {{ eduQualitification.degreeCertification }}
              </h2>
              <h3 class="edu__details text-xl">
                {{ eduQualitification.organization }} |
                <span> {{ formatDate(eduQualitification.startDate) }}</span>
                - {{ formatDate(eduQualitification.endDate) }} (Year) |<span
                  v-if="eduQualitification.grade"
                >
                  {{ eduQualitification.grade }}% |
                </span>
                <span v-if="eduQualitification.city"
                  >{{ eduQualitification.city }} |
                </span>

                <span v-if="eduQualitification.country">{{
                  eduQualitification.country.label
                }}</span>
              </h3>
            </div>
            <div
              :style="{ borderColor: colorObj }"
              class="vertical-bar vertical-bar--edu"
            />
          </div>
        </div>
        <div
          v-if="
            userData.extraCurricular[0].hobbies &&
            userData.extraCurricular[0].hobbies.length > 0
          "
          class="hobbies"
          :style="{ borderColor: colorObj }"
        >
          <h2
            class="font-bold text-center mb-2 relative z-10"
            :style="{ color: colorObj }"
          >
            Hobbies
          </h2>
          <div class="hobbies__list overflow-auto">
            <div
              class="flex my-2"
              v-for="(hobby, index) in userData.extraCurricular[0].hobbies"
              :key="index"
            >
              <!-- <span class="oval__bullets" /> -->
              <img
                class="hobbies__h-fit"
                :src="bulletsImg[userData.templateColorCode]"
              />
              <p class="ml-2 text-xl font-bold text-black capitalize">
                {{ hobby.metaData.label }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="userData.careerHistory && userData.careerHistory.length > 0"
        class="career__history my-12"
      >
        <h2
          class="career__history__heading font-bold mb-6"
          :style="{ color: colorObj, borderColor: colorObj }"
        >
          Career History
        </h2>
        <div
          class="career__history__details --box"
          :style="{ borderColor: colorObj }"
        >
          <div
            v-for="(careerHistory, index) in userData.careerHistory"
            :key="index"
            class="career__history__details flex p-2 lg:p-0 my-2 lg:my-6 relative"
            :style="{ borderColor: colorObj }"
          >
            <div class="career__history__details__left xl:w-1/5">
              <h2
                v-if="careerHistory"
                class="font-bold mb-2"
                :style="{ color: colorObj }"
              >
                {{ careerHistory.title }}
              </h2>
              <h3 class="edu__details">
                {{ careerHistory.company }}
                <span v-if="careerHistory.city"
                  >{{ careerHistory.city }} |
                </span>

                <span v-if="careerHistory.country">{{
                  careerHistory.country.label
                }}</span>
              </h3>
            </div>
            <div
              class="vertical-bar vertical-bar--2 mx-2 lg:mx-6"
              :style="{ borderColor: colorObj }"
            />
            <p
              class="career__history__details__right text-justify lg:text-xl font-bold text-black xl:w-4/5"
            >
              {{ careerHistory.description }}
            </p>
          </div>
        </div>
      </div>

      <div
        v-if="
          userData.projects &&
          userData.projects.length > 0 &&
          userData.projects[0].title
        "
        class="projects my-2 lg:my-6"
      >
        <h2
          class="projects__heading font-bold mb-6"
          :style="{ color: colorObj, borderColor: colorObj }"
        >
          Projects
        </h2>
        <div
          class="projects__outer projects__details --box"
          :style="{ borderColor: colorObj }"
        >
          <div
            class="projects__details p-0 w-full"
            :style="{ borderColor: colorObj }"
          >
            <div
              v-for="(project, index) in userData.projects"
              :key="index"
              :style="{ borderColor: colorObj }"
              class="projects__details flex relative overflow-hidden"
            >
              <span
                v-if="project"
                class="projects__details__container flex p-2 lg:p-0"
                :class="project.projectPictureUrl ? 'w-4/5' : 'w-full'"
              >
                <div class="projects__details__left xl:w-1/5">
                  <h2
                    v-if="project.title"
                    class="font-bold mb-2"
                    :style="{ color: colorObj }"
                  >
                    {{ project.title }}
                  </h2>
                  <h3
                    v-if="project.organization"
                    class="projects__details__left__organization"
                  >
                    {{ project.organization }}
                  </h3>
                </div>
                <div
                  :style="{ borderColor: colorObj }"
                  class="vertical-bar vertical-bar--2 vertical-bar--3 mx-2 lg:mx-6"
                />
                <p
                  class="projects__details__right lg:text-xl font-bold text-justify text-black"
                  :class="[
                    project.projectPictureUrl ? '' : 'w-4/5',
                    checked && checkedId === index ? '' : 'clamped-text',
                  ]"
                >
                  {{ project.description }}
                </p>
                <button
                  v-if="project.description && project.description.length > 0"
                  @click="toggleCheck(index)"
                  :style="{ backgroundColor: colorObj + '99' }"
                >
                  {{ checked && checkedId === index ? "Less" : "More" }}
                </button>
              </span>
              <span
                class="projects__details__img-container flex justify-center p-2 lg:p-0"
                v-if="project.projectPictureUrl"
                :class="project.projectPictureUrl ? 'w-1/5' : 'w-0'"
              >
                <img
                  v-if="project.projectPictureUrl"
                  class="projects__details__img object-cover"
                  :src="
                    constants.s3Bucket +
                    '/editor/project-pictures/' +
                    project.projectPictureUrl
                  "
                  alt=""
              /></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import defaultAvatar from "@/assets/images/gala-images/layout/avtar.png";
import charisma from "@/assets/images/gala-images/layout/Charisma.png";
import wisdom from "@/assets/images/gala-images/layout/Wisdom.png";
import compassion from "@/assets/images/gala-images/layout/Compassion.png";
import intelligence from "@/assets/images/gala-images/layout/Intelligence.png";
import strength from "@/assets/images/gala-images/layout/Strength.png";
import dexterity from "@/assets/images/gala-images/layout/Dexterity.png";
import char from "@/assets/images/gala-images/layout/Half-Orc-Paladin.png";
import twitter from "@/assets/images/gala-images/layout/twitter.png";
import facebook from "@/assets/images/gala-images/layout/facebook.png";
import linkedin from "@/assets/images/gala-images/layout/linkedin.png";
import website from "@/assets/images/gala-images/layout/website.png";
import moment from "moment";
import constants from "@/constants";
import organizationConfig from "@/assets/data/organization-config.js";
import characterCardsGala from "@/assets/data/character-cards-gala";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import * as imageToBase64 from "image-to-base64";
export default {
  name: "LightCharacterCard",
  data() {
    return {
      defaultAvatar,
      organizationConfig,
      characterCardsGala,
      charisma,
      wisdom,
      compassion,
      intelligence,
      strength,
      dexterity,
      char,
      constants,
      facebook,
      twitter,
      linkedin,
      website,
      count: "",
      // orgSlug: "default",
      // color: "#fff",
      userProfilePicture: null,
      bulletsImg: {
        "#3BA0BE": require("@/assets/images/gala-images/bullets/blue-bullet.png"),
        "#6859B4": require("@/assets/images/gala-images/bullets/purple-bullet.png"),
        "#008000": require("@/assets/images/gala-images/bullets/green-bullet.png"),
        "#B3B3B3": require("@/assets/images/gala-images/bullets/grey-bullet.png"),
        "#C6211B": require("@/assets/images/gala-images/bullets/red-bullet.png"),
        "#E4D033": require("@/assets/images/gala-images/bullets/yellow-bullet.png"),
        "#EA7526": require("@/assets/images/gala-images/bullets/orange-bullet.png"),
        "#F36677": require("@/assets/images/gala-images/bullets/pink-bullet.png"),
      },
      selectedGalaAvatar: "",
      selectedGalaAvatarGender: "",
      checked: false,
      checkedId: "",
    };
  },
  watch: {
    userData(newVal) {
      this.converImgToBase64(
        `${this.constants.s3Bucket}/editor/profile-pictures/${newVal.profilePictureUrl}`
      );
      this.fetchGalaAvatar(newVal._id);
      this.$store.dispatch("users/fetchGalaAbilities", { userId: newVal._id });
    },
    galaAvatar: {
      handler(val) {
        if (val.split("-")[0]) {
          this.selectedGalaAvatar = val.split("-")[0];
        } else {
          this.selectedGalaAvatar = "monk";
        }

        if (val.split("-")[1]) {
          this.selectedGalaAvatarGender = val.split("-")[1];
        } else if (this.userData && this.userData.gender) {
          this.selectedGalaAvatarGender = this.userData.gender;
        } else {
          this.selectedGalaAvatarGender = "male";
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    userData() {
      return this.$store.state.users.data;
    },
    galaAvatar() {
      return (
        this.$store.state.users.galaAvatar.charAt(0).toUpperCase() +
        this.$store.state.users.galaAvatar.slice(1)
      );
    },

    colorObj() {
      let color = this.userData.templateColorCode;
      if (color === "#C6211B") {
        return (color = "#C31432");
      } else if (color === "#E4D033") {
        return (color = "#F29300");
      } else if (color === "#F36677") {
        return (color = "#FF7B91");
      } else if (color === "#3BA0BE") {
        return (color = "#67D8F3");
      } else if (color === "#6859B4") {
        return (color = "#7140FF");
      } else if (color === "#008000") {
        return (color = "#44CC88");
      } else {
        return color;
      }
    },
    organizationSlug() {
      return this.$route.params.boardSlug
        ? this.orgSlug
        : this.$store.state.organization.organizationSlug;
    },
    locale() {
      return this.$i18n.locale;
    },
    personalityData() {
      if (this.userOrganizations && this.orgSlug === "gala") {
        return this.organizationConfig["gala"].personalityTraits[this.locale];
      } else
        return this.organizationConfig["default"].personalityTraits[
          this.locale
        ];
    },
    galaAbilities() {
      return this.$store.state.users.galaAbilities;
    },
    userOrganizations() {
      return this.$store.state.organization.orgData;
    },
    orgSlug() {
      return this.$store.state.organization.organizationSlug;
    },
  },
  methods: {
    toggleCheck(id) {
      if (this.checkedId === id) {
        this.checked = !this.checked;
      } else if (this.checkedId !== id) {
        this.checked = true;
        this.checkedId = id;
      }
    },
    formatDate(date) {
      return moment(date).format("YYYY");
    },
    getPersonalityTraitById(id) {
      if (id) {
        const p = this.personalityData.find((pd) => {
          return pd.id === id || pd.personalityMapId - 36 === id;
        });
        return p;
      }
      return {};
    },
    getCharacterTypeCount(ccg) {
      let count = 0;
      if (this.galaAbilities && this.galaAbilities.length) {
        this.galaAbilities.forEach((personalityMapId, index) => {
          if (
            index < 6 &&
            this.getPersonalityTraitById(personalityMapId) &&
            this.getPersonalityTraitById(personalityMapId).characterType ===
              ccg.slug
          ) {
            count++;
          }
        });
      }
      return count ? `+${count}` : 0;
    },
    getTwitterUsername(text) {
      const regex = new RegExp(
        "(?:https?:\\/\\/)?(?:www\\.)?twitter\\.com\\/(?:#!\\/)?@?([^\\/\\?\\s]*)",
        ""
      );
      let m;
      if ((m = regex.exec(text)) !== null) {
        m.forEach((match, groupIndex) => {});
      }
      return text && m[1] ? m[1] : "";
    },
    getFacebookUsername(text) {
      const regex =
        /(((https?:\/\/)?(www\.)?facebook\.com\/))?(.*\/)?([a-zA-Z0-9.]*)($|\\?.*)/;
      let m;
      if ((m = regex.exec(text)) !== null) {
        m.forEach((match, groupIndex) => {});
      }
      return text && m[6] ? m[6] : "";
    },
    getLinkedinUsername(text) {
      const regex =
        /(https?:\/\/(www.|de.)?linkedin.com\/(mwlite\/|m\/)?in\/([a-zA-Z0-9À-ž_.-]+)\/?)/gm;
      let m;
      if ((m = regex.exec(text)) !== null) {
        m.forEach((match, groupIndex) => {});
      }
      return text && m && m[4] ? m[4] : "";
    },
    removeHttp(url) {
      return url.replace(/^https?:\/\//, "");
    },
    async imgToBase64(img) {
      let imgRes = "";
      await imageToBase64(img)
        .then((res) => {
          imgRes = res;
          console.log("res", res);
          return res;
        })
        .catch((err) => {
          throw err;
        });

      return imgRes;
    },
    async converImgToBase64(url) {
      try {
        // # is added for a fresh server load
        const data = await fetch(url + "?#" + new Date().getTime());
        // console.log(data);
        const blob = await data.blob();
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            const base64data = reader.result;
            this.userProfilePicture = base64data;
            // // console.log(this.userProfilePicture);
            resolve(base64data);
          };
        });
      } catch (err) {
        throw err;
      }
    },
    async generatePDF() {
      // this.$refs.html2Pdf.generatePdf();

      /*html2pdf(this.$refs.prestigeDocument, {
          margin: 0,
          filename: `${this.userData.firstName}-${this.userData.lastName}.pdf`,
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: {scale: 4, dpi: 192, letterRendering: true },
          jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' },
          enableLinks: true,
          pagebreak: { mode: ['avoid-all'] },
        }).then(() => {
          this.$vs.loading.close();
        })*/

      const pdfName = `${this.userData.firstName}-${this.userData.lastName}.pdf`;
      const vsLoading = this.$vs.loading;

      await html2canvas(this.$refs.lightcharactercardDocument).then(function (
        canvas
      ) {
        var a = document.createElement("a");
        // toDataURL defaults to png, so we need to request a jpeg, then convert for file download.
        a.href = canvas.toDataURL("image/jpeg", 1.0);
        // a.download = 'somefilename.jpeg';
        // a.click();

        const img = new Image();
        img.onload = async function () {
          // // console.log(this.width + 'x' + this.height);
          let pdf = new jsPDF("p", "px", [this.width, this.height]);
          if (this.width > this.height) {
            pdf = new jsPDF("l", "px", [this.width, this.height]);
          }
          await pdf.addImage(a.href, "JPEG", 0, 0, this.width, this.height);
          await pdf.save(pdfName);
          vsLoading.close();
        };
        img.src = a.href;
      });
    },
    findOrgSlug() {
      const boardSlug = this.$route.params.boardSlug;
      this.$store
        .dispatch("boards/fetchBoardBySlug", boardSlug)
        .then((boardRes) => {
          this.orgSlug = boardRes.data[0].orgData.slug;
        })
        .catch((err) => {
          throw err;
        });
    },
    async fetchGalaAvatar(userId) {
      this.$store.dispatch("users/fetchGalaAvatar", { userId });
    },
  },
  mounted() {
    this.$root.$on("downloadResume", () => {
      this.generatePDF();
    });

    // convert profile picture to base64
    if (this.userData && this.userData.profilePictureUrl) {
      // // console.log(this.userData);
      this.converImgToBase64(
        `${this.constants.s3Bucket}/editor/profile-pictures/${this.userData.profilePictureUrl}`
      );
    }
  },
  created() {
    if (this.$route.params.boardSlug) {
      this.findOrgSlug();
    } else {
      this.orgSlug = this.organizationSlug;
    }
    this.fetchGalaAvatar(this.userData._id);
    if (this.userData && this.userData._id)
      this.$store.dispatch("users/fetchGalaAbilities", {
        userId: this.userData._id,
      });
  },
};
</script>

<style lang="scss" scoped>
@import "/css/commoncharactercard.scss";
</style>
